<template>
  <div
      v-if="!isDeleted"
    class="relative rounded p-4 md:max-w-lg md:w-max-content"
    :class="{
      'self-end bg-green-200': isCurrentUser,
      'bg-gray-200': !isCurrentUser && isClient,
      'bg-white': !isCurrentUser && !isClient,
      'hidden': isNotificationHidden,
    }"
    @mouseenter="hover= true"
    @mouseleave="hover= false"
  >
      <div class="delete" :class="{'bg-red-400':hover}" v-if="hasRoles(['DIRECCIÓN','ADMINISTRACIÓN','EQUIPO EUROPROSEM']) && today">
        <span v-if="hover" @click="deleteNotification">X</span>
      </div>
    <div :class="{'text-right': isCurrentUser}">
      <p class="tracking-wide normal-case" v-html="item.comentario" />
      <div class="text-gray-700 leading-5 text-xs mt-1">
        <span>
          {{ item.nombre }} &#8226; {{ item.fecha|datetime }}
        </span>
      </div>
      <div
        class="absolute w-2 h-2 origin-center transform rotate-45 -translate-y-0 pointer-events-none"
        :class="{
          'right-0 bg-green-200 translate-x-1': isCurrentUser,
          'left-0 bg-gray-200 -translate-x-1': !isCurrentUser && isClient,
          'left-0 bg-white -translate-x-1': !isCurrentUser && !isClient,
        }"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "NotificationItem",
    data(){
      return{
          hover:false,
          isDeleted:false
      }
    },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    hidden: {
      type: Boolean,
      default: false
    },
    showAllNotifications: {
      type: Boolean,
      default: false
    },
    isClient: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isCurrentUser() {
      return this.item.idUser == this.user.id;
    },
    isNotificationHidden() {
      if (this.showAllNotifications) return false;
      else if (this.hidden) return true;
      else return false;
    },
      today(){
        const d = new Date(this.item.fecha);
        const today =new Date();
        return d.toLocaleDateString('es') == today.toLocaleDateString('es')
      }
  },
    methods:{
        deleteNotification(){
            if (this.isClient){
                this.$axios.post(`api/Notificaciones/DeleteComentario`,{idCommentClientNotification:this.item.idCommentClientNotification})
            }else{
                this.$axios.post(`api/Notificaciones/DeleteComentario`,{IdCommentFactoryNotification:this.item.idCommentClientNotification})
            }
            this.isDeleted=true
        }

    }
};
</script>
<style scoped>
.delete{
    margin-left: auto;
    width: 2rem !important;
    height: 2rem !important;
    color: white;
    padding: 0.2em;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
